/**
 * OFManager official logo — Vague 99.7.
 *
 * The full PNG (mark + wordmark + tagline, provided by the user) lives at
 * /logo-ofmanager.png.
 *
 * Two rendering modes:
 *  - variant="mark"  (default) → crops to the square icon only, ideal for
 *    collapsed sidebars, favicons, avatars. We stack the PNG inside a
 *    positioned wrapper so we can use `object-fit: cover + objectPosition`
 *    to reveal just the mark (left third of the PNG).
 *  - variant="full"  → shows the complete artwork (mark + "OFManager" wordmark
 *    + tagline). Use on login, marketing pages, footer of emails.
 */
import React from 'react';

const SRC = '/logo-ofmanager.png';

export default function Logo({ size = 40, variant = 'mark', className = '', alt = 'OFManager' }) {
  if (variant === 'full') {
    return (
      <img
        src={SRC}
        alt={alt}
        className={className}
        style={{ height: size, width: 'auto', display: 'block' }}
      />
    );
  }
  // Mark only — the provided PNG has the icon in roughly the left 22% of the
  // artwork. We crop with object-fit cover + objectPosition so the square
  // wrapper only shows the icon.
  return (
    <span
      className={`inline-block rounded-xl overflow-hidden ${className}`}
      style={{ width: size, height: size, verticalAlign: 'middle' }}
    >
      <img
        src={SRC}
        alt={alt}
        style={{
          width: 'auto',
          height: '100%',
          objectFit: 'cover',
          objectPosition: 'left center',
          transform: 'scale(1.05)',
          transformOrigin: 'left center',
          display: 'block',
        }}
      />
    </span>
  );
}
